import { get, isEmpty } from 'lodash';
import FormConfigUtils from './FormConfigUtils';
import Messages from '../../common/validation/Messages';

const getAllField = (data, category, subcategory) => {
  const fieldsFromCat = FormConfigUtils.getCustomFieldsInCategory(data, category);
  const fieldsFromSubcat = FormConfigUtils.getCustomFields(data, category, subcategory);
  return [...fieldsFromCat, ...fieldsFromSubcat];
};

const hasValueMonthDay = (values, path) => {
  const month = get(values, `${path}Month`);
  const year = get(values, `${path}Year`);
  return !isEmpty(month) || !isEmpty(year);
};

/**
 * Added additional validation rules for any dynamic fields added to the form that require validation.
 * @param data data the dynamic form config json to look in.
 * @param category used to determine which if any dynamic fields are included on the form.
 * @param subcategory used to determine which if any dynamic fields are included on the form.
 * @param requiredFields list if require field to which any additional fields found by this
 * function will be added.
 */
const addCustomFieldsValidation = (data, category, subcategory, requiredFields) => {
  const fields = getAllField(data, category, subcategory);
  if (fields) {
    fields.forEach((item) => {
      if (item.isRequired || item.required) {
        if (item.fieldType === 'month-year') {
          requiredFields.push({ name: `${item.name}Month`, errorMessage: Messages.REQUIRED_MONTH });
          requiredFields.push({ name: `${item.name}Year`, errorMessage: Messages.REQUIRED_YEAR });
        } else {
          requiredFields.push({ name: item.name, errorMessage: Messages.REQUIRED_MESSAGE });
        }
      }
    });
  }
};

/**
 * Determine if the dynamic form should be validated ar all.
 * Current based on where there have been any dynamic fields added to the form,
 * other then the submit button.
 * ToDo: This could be improved to take into account whether any of the dynamic fields are required.
 *
 * @param data the dynamic form config json to look in.
 * @param category used to determine which if any dynamic fields are included on the form.
 * @param subcategory used to determine which if any dynamic fields are included on the form.
 * @returns {boolean} true if and only if the form requires validation.
 */
const shouldValidate = (data, category, subcategory) => {
  const fields = getAllField(data, category, subcategory);
  if (fields) {
    const field = fields.filter(item => item.fieldType === 'submit-button');
    return field.length >= 1;
  }
  return false;
};

export default {
  addCustomFieldsValidation,
  shouldValidate,
  hasValueMonthDay
};



/** WEBPACK FOOTER **
 ** ./src/components/form/FormValidationUtils.js
 **/